import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export const HtmlPageTitle = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'PageTitle' });
  return <Helmet defaultTitle={t('fallback')} titleTemplate={t('template', { title: '%s' })}></Helmet>;
};
